/**
 * @memberof feature-references
 */
class LayerRecord {
    /**
     * @param {object} props
     * @param {feature-references.LayerReference} props.ref
     * @param {string} props.label
     */
    constructor(props) {
        this.ref = props.ref;
        this.label = props.label;
    }
    /**
     * @param {feature-references.LayerReference}
     * @return {boolean}
     */
    isEqual(ref) {
        return ref.key === this.key;
    }
    /**
     * @type {string}
     */
    get key() {
        return this.ref.key;
    }
}
export default LayerRecord;
